import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { HexNumber } from '@lukso/controllerapps-sharedlogic-primitives'

const AddressPermissionsLengthPropsSchema = z.object({
  addressPermissionsLengthValue: z.instanceof(HexNumber),
})

type AddressPermissionsLengthProps = z.infer<
  typeof AddressPermissionsLengthPropsSchema
>

export class AddressPermissionsLength extends ValueObject<AddressPermissionsLengthProps> {
  public getValue(): HexNumber {
    return this.props.addressPermissionsLengthValue
  }

  /**
   * @returns The length value as a decimal number.
   */
  public getDecimalValue(): number {
    return this.getValue().getDecimalValue()
  }

  public static create(
    props: AddressPermissionsLengthProps
  ): AddressPermissionsLength {
    const validatedProps = AddressPermissionsLengthPropsSchema.parse(props)
    return new AddressPermissionsLength(validatedProps)
  }
}
